import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useAxios from 'axios-hooks';
import isEmpty from 'lodash.isempty';
import { ProfileTabs } from '../../../components';
import { Link } from 'react-router-dom';

const SMSAlerts = ({ user, showNotification }) => {
	const userRaw = user.toJSON();
	const appointment_only_ind = !!user.get('appointment_only_ind');

	const [isUpdating, setIsUpdating] = useState(false);
	const [send_my_patients_to_oncall_ind, setSendMyPatientsToOncallInd] =
		useState(!!user.get('send_my_patients_to_oncall_ind'));
	const [oncall_pool_ind, setOncallPoolInd] = useState(
		!!user.get('oncall_pool_ind')
	);
	const [adt_notifications_ind, setAdtNotificationsInd] = useState(
		!!user.get('adt_notifications_ind')
	);
	const [assessment_notifications_ind, setAssessmentNotificationsInd] =
		useState(!!user.get('assessment_notifications_ind'));
	const [email_adt_alerts, setEmailADTAlerts] = useState(
		!!user.get('email_adt_alerts')
	);

	const [
		{
			data: practiceProvidersResponse,
			loading: isLoadingPracticeProviders /* error */,
		},
		getPracticeProviders,
	] = useAxios({
		method: 'GET',
		url: `/provider_practices/${userRaw.provider_practice_id}/list-providers`,
	});

	const [practiceProviders, setPracticeProviders] = useState([]);
	const [availableProviders, setAvailableProviders] = useState([]);
	const [unavailableProviders, setUnavailableProviders] = useState([]);

	useEffect(() => {
		if (
			!isEmpty(practiceProvidersResponse) &&
			!isLoadingPracticeProviders &&
			Array.isArray(practiceProvidersResponse.status)
		) {
			setPracticeProviders(practiceProvidersResponse.status);
		}
	}, [practiceProvidersResponse, isLoadingPracticeProviders]);
	useEffect(() => {
		setSendMyPatientsToOncallInd(user.get('send_my_patients_to_oncall_ind'));
		setOncallPoolInd(user.get('oncall_pool_ind'));
		setAdtNotificationsInd(user.get('adt_notifications_ind'));
		setAssessmentNotificationsInd(user.get('assessment_notifications_ind'));
		setEmailADTAlerts(user.get('email_adt_alerts'));
	}, [isUpdating]);
	useEffect(() => {
		getPracticeProviders();
	}, [oncall_pool_ind, send_my_patients_to_oncall_ind]);
	useEffect(() => {
		setAvailableProviders(
			practiceProviders.filter((provider) => !!provider.oncall_pool_ind)
		);
		setUnavailableProviders(
			practiceProviders.filter((provider) => !provider.oncall_pool_ind)
		);
	}, [practiceProviders]);

	const handleFormItemUpdate = ({ target }) => {
		setIsUpdating(true);
		user.set(target.name, target.value);
		const toastId = showNotification({
			message: 'Updating Preferences',
			loading: true,
		});
		user
			.save()
			.done(() => {
				showNotification({
					toastId,
					status: 'success',
					message: 'Preferences Updated',
					timeout: 1200,
				});
			})
			.fail(() => {
				showNotification({
					toastId,
					status: 'error',
					message:
						'There was a problem updating your preferences. Please try again.',
					timeout: 3000,
				});
			})
			.always(() => {
				setIsUpdating(false);
			});
	};

	return (
		<div className="content-wrapper adt-notification-prefs">
			<ProfileTabs activeTab="sms-alerts" />
			<div className="container mt-xl">
				<form className="form-horizontal">
					<fieldset>
						<div className="row">
							<div className="col-md-8">
								{/* <div className="form-group">
									<label className="col-md-8 control-label">Visit Types Allowed</label>
									<div className="col-md-4 pb">
										<select
											className="form-control"
											name="byApptOnly"
											value={appointment_only_ind}
											disabled={isUpdating}
											onChange={handleFormItemUpdate}
										>
											<option value={true}>Appointment Only</option>
											<option value={false}>Appointment and On-Demand</option>
										</select>
									</div>
								</div> */}
								<div className="form-group">
									<label className="col-md-8 control-label">
										Send me SMS alerts for my patient visits
									</label>
									<div className="col-md-4">
										<select
											className="form-control"
											name="send_my_patients_to_oncall_ind"
											value={send_my_patients_to_oncall_ind}
											disabled={appointment_only_ind || isUpdating}
											onChange={handleFormItemUpdate}
										>
											<option value={false}>Yes</option>
											<option value={true}>No</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</fieldset>
					<fieldset>
						<div className="row">
							<div className="col-md-8">
								<div className="form-group pb">
									<label className="col-md-8 control-label">
										Send me SMS alerts for all new practice visits
									</label>
									<div className="col-md-4">
										<select
											className="form-control"
											name="oncall_pool_ind"
											value={oncall_pool_ind}
											disabled={isUpdating}
											onChange={handleFormItemUpdate}
										>
											<option value={true}>Yes</option>
											<option value={false}>No</option>
										</select>
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-3 col-md-offset-3">
								<div>
									<strong>
										Will receive SMS alerts for all practice visits
									</strong>{' '}
									({availableProviders.length}/{practiceProviders.length})
								</div>
								{availableProviders.map(
									({ id, name_first, name_last, credentials }) => (
										<div className="text-success" key={`${id}`}>
											<em className="icon-call-in"></em> {name_first}{' '}
											{name_last} {credentials}
										</div>
									)
								)}
							</div>
							<div className="col-md-6">
								<div>
									<strong>
										Will not receive SMS alerts for all practice visits
									</strong>{' '}
									({unavailableProviders.length}/{practiceProviders.length})
								</div>
								{unavailableProviders.map(
									({ id, name_first, name_last, credentials }) => (
										<div className="text-danger" key={`${id}`}>
											<em className="icon-call-in"></em> {name_first}{' '}
											{name_last} {credentials}
										</div>
									)
								)}
							</div>
						</div>
					</fieldset>
					<fieldset>
						<div className="row">
							<div className="col-md-8">
								<div className="form-group">
									<label className="col-md-8 control-label">
										Send me SMS alerts when there is a new ADT message
									</label>
									<div className="col-md-4 pb">
										<select
											className="form-control"
											name="adt_notifications_ind"
											value={adt_notifications_ind}
											disabled={isUpdating}
											onChange={handleFormItemUpdate}
										>
											<option value={true}>Yes</option>
											<option value={false}>No</option>
										</select>
									</div>
								</div>
								<div className="form-group">
									<label className="col-md-8 control-label">
										Send me Email alerts when there is a new ADT message
									</label>
									<div className="col-md-4">
										<select
											className="form-control"
											name="email_adt_alerts"
											value={email_adt_alerts}
											disabled={isUpdating}
											onChange={handleFormItemUpdate}
										>
											<option value={true}>Yes</option>
											<option value={false}>No</option>
										</select>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<Link
									to="/profile/adt-notification-prefs"
									className="btn btn-link"
								>
									ADT Notification Preferences
								</Link>
							</div>
						</div>
					</fieldset>
					<fieldset>
						<div className="row">
							<div className="col-md-8">
								<div className="form-group">
									<label className="col-md-8 control-label">
										Send me SMS alerts when there are new Assessments
									</label>
									<div className="col-md-4 pb">
										<select
											className="form-control"
											name="assessment_notifications_ind"
											value={assessment_notifications_ind}
											disabled={isUpdating}
											onChange={handleFormItemUpdate}
										>
											<option value={true}>Yes</option>
											<option value={false}>No</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</fieldset>
				</form>
			</div>
		</div>
	);
};

SMSAlerts.propTypes = {
	user: PropTypes.object.isRequired,
	showNotification: PropTypes.func.isRequired,
};

export default SMSAlerts;
